import AltQuoteEmailSection from "./AltQuoteEmailSection";

export default AltQuoteEmailSection;
